import {
  LocalShippingOutlined as LocalShippingIcon,
  SearchOutlined as SearchIcon,
  TrackChangesOutlined as TrackChangesIcon,
} from '@mui/icons-material';
import { BOT_INTENTS } from './intents';
import { QuickActionItem } from '../types/intent.types';

export const DEFAULT_QUICK_ACTIONS: QuickActionItem[] = [
  {
    label: 'Create Shipment',
    query: 'Create shipment',
    intent: BOT_INTENTS.PLACE_SHIPMENT,
    icon: LocalShippingIcon,
  },
  {
    label: 'Find Quotes',
    query: 'Find quotes',
    intent: BOT_INTENTS.FIND_QUOTES,
    icon: SearchIcon,
  },
  {
    label: 'Track Shipment',
    query: 'Track shipment',
    intent: BOT_INTENTS.TRACK_SHIPMENT,
    icon: TrackChangesIcon,
  },
];
